










import { Vue, Prop, Component } from 'vue-property-decorator'
import { formatCurrency, unFormatCurrency } from '@/utils/helpers'

@Component
export default class CurrencyInput extends Vue {
  @Prop() value!: number | string
  @Prop({ default: '' }) placeholder?: string
  @Prop({ default: 0 }) min?: number

  public string: string = formatCurrency(this.value)

  changeHandle(value) {
    if (unFormatCurrency(value) <= Number(this.min)) {
      this.string = formatCurrency(this.min)
    } else {
      this.string = ''
      setTimeout(() => {
        this.string = formatCurrency(unFormatCurrency(value))
      })
    }
  }
  blurHandle() {
    this.$emit('onChange', unFormatCurrency(this.string))
  }
}
